import React, { useEffect } from "react";
import { Helmet } from "react-helmet-async";
import Footer from "../components/Footer";
import { useLocation } from "react-router-dom";
import LocationsHero from "../components/locations/LocationsHero";
import USColoredMap from "../components/locations/USColoredMap";
import StateSection from "../components/locations/StateSection";
import { locationsData } from "../data/locationsData";

const Locations = () => {
  const location = useLocation();

  useEffect(() => {
    if (location.hash) {
      const element = document.getElementById(location.hash.slice(1));
      if (element) {
        element.scrollIntoView({ behavior: "smooth" });
      }
    } else {
      window.scrollTo(0, 0);
    }
  }, [location]);

  const servicedStates = locationsData.map(loc => loc.title);

  return (
    <div className="min-h-screen flex flex-col bg-gray-100">
      <Helmet>
        <title>Traffic Control Service Locations | USA Traffic Control</title>
        <meta name="description" content="USA Traffic Control provides professional traffic management services across the Western United States. Find our service locations and coverage areas." />
        <meta name="keywords" content="traffic control locations, service areas, USA traffic control" />
        <link rel="canonical" href="https://usatrafficcontrol.com/locations" />
      </Helmet>
      
      <LocationsHero />

      {/* Title Section */}
      <div className="py-8 pb-4 bg-gray-100">
        <div className="container mx-auto px-4">
          <h2 className="text-2xl md:text-3xl font-bold text-center text-gray-900 mb-4">
            USA Traffic Control Locations
          </h2>
        </div>
      </div>

      {/* Serviced States Bullet List */}
      <div className="bg-gray-100 mb-2">
        <div className="container mx-auto px-4 flex flex-wrap justify-center gap-4">
          {servicedStates.map((state) => {
            const locationData = locationsData.find(loc => loc.title === state);
            if (!locationData) return null;
            
            return (
              <button
                key={state}
                onClick={() => {
                  const element = document.getElementById(locationData.id);
                  if (element) {
                    element.scrollIntoView({ behavior: "smooth" });
                  }
                }}
                className="group flex items-center gap-2 bg-orange-100 hover:bg-orange-200 px-4 py-2 text-orange-700 font-semibold text-sm shadow-sm 
                           transition-all duration-300 hover:scale-105 hover:shadow-md active:scale-95"
              >
                <span className="w-2 h-2 bg-orange-500 group-hover:bg-orange-600 transition-colors" />
                {state}
              </button>
            );
          })}
        </div>
      </div>

      {/* Map Section */}
      <div className="bg-gray-100 pt-0 pb-8">
        <div className="container max-w-4xl mx-auto px-4">
          <div className="w-full">
            <USColoredMap />
          </div>
        </div>
      </div>

      {/* State Sections */}
      {locationsData.map((location, index) => (
        <StateSection 
          key={location.id} 
          location={location} 
          index={index} 
        />
      ))}

      <Footer />
    </div>
  );
};

export default React.memo(Locations);
